import i18next from "../i18n";
import View from "./View";

class DeliveryView extends View {
  _address = undefined;
  _apartmentNumber = undefined;
  _bigBasket = document.querySelector(".big-basket-button");
  _btnCloseService = document.querySelector(".button-close.service");
  _continueBtn = document.querySelector(".continue-button");
  _country = document.querySelector("#country");
  _data;
  _email = document.querySelector("#email");
  _emailValidationField = document.querySelector(".email-validation");
  _formCustomerInfo = document.querySelector(".form-customer-info");
  _lookupState = null;
  _modalBackgroundService = document.querySelector(".modal-background.service");
  _name = document.querySelector("#name");
  _phoneNumber = document.querySelector("#phone-number");
  _phoneNumberValidationField = document.querySelector(
    ".phone-number-validation",
  );

  // Clear the content of the elements
  _clear() {
    this._addressForm.innerHTML = "";
  }

  // Returns false if the last address lookup produced a validation error, true otherwise.
  // null lookupState means the user has not typed in the field yet — treated as valid.
  _isAddressLookupValid() {
    if (this._lookupState === null) {
      return true;
    }

    if (this._lookupState.hasAddresses) {
      return true;
    }
    return this._lookupState.validationKey === null;
  }

  _showAddressError(message) {
    const SHAKEDURATION = 1000;
    const _addressField = document.querySelector("#address");
    const _addressValidationField = document.querySelector(
      ".address-validation",
    );
    const addressContainer = document.querySelector(".address-container");

    _addressValidationField.textContent = message;
    _addressValidationField.style.display = "block";
    _addressField.style.marginBottom = "5.5px";

    addressContainer.classList.add("shake");
    setTimeout(() => {
      addressContainer.classList.remove("shake");
    }, SHAKEDURATION);

    return false;
  }

  // Hide modal Service
  closeModalService() {
    [this._btnCloseService, this._modalBackgroundService].forEach((el) => {
      el.onclick = () => {
        // Hide service modal
        this._overlayService.style.display = "none";

        // Show scroll bar and prevent scroll
        document.body.style.overflow = "visible";
        document.documentElement.style.removeProperty("overflow");
        document.body.style.removeProperty("height");
        document.documentElement.style.height = "100vh";
      };
    });
  }

  handlerDeliveryFormSubmit(handler) {
    this._formCustomerInfo.addEventListener("submit", (event) => {
      // Prevent form submission
      event.preventDefault();

      // Get the current pattern from the input's pattern attribute
      const currentPattern = new RegExp(this._phoneField.pattern, "u");

      const _addressField = document.querySelector("#address");
      const MIN_ADDRESS_LENGTH = 10;

      const isValid =
        currentPattern.test(this._phoneNumber.value) &&
        this.testEmail(this._email.value) &&
        _addressField.value.trim().length >= MIN_ADDRESS_LENGTH &&
        this._isAddressLookupValid();

      // Validate phone number
      this.validatePhoneNumber();

      // Validate email
      this.validateEmail();

      // Validate address
      this.validateAddress();

      // Validate email
      if (isValid) {
        handler();

        // Hide service modal
        this._overlayService.style.display = "none";

        // Show scroll bar and prevent scroll
        document.body.style.overflow = "visible";
        document.documentElement.style.removeProperty("overflow");
        document.body.style.removeProperty("height");
        document.documentElement.style.height = "100vh";

        // Open modal checkout
        this.openModalCheckout();
      }
    });
  }

  handlerPickupFormSubmit(handler) {
    this._formCustomerInfo.addEventListener("submit", (event) => {
      // Prevent form submission
      event.preventDefault();

      // Get the current pattern from the input's pattern attribute
      const currentPattern = new RegExp(this._phoneField.pattern, "u");

      const isValid =
        currentPattern.test(this._phoneNumber.value) &&
        this.testEmail(this._email.value);

      // Validate phone number
      this.validatePhoneNumber();

      // Validate email
      this.validateEmail();

      // Validate email
      if (isValid) {
        handler();

        // Hide service modal
        this._overlayService.style.display = "none";

        // Show scroll bar and prevent scroll
        document.body.style.overflow = "visible";
        document.documentElement.style.removeProperty("overflow");
        document.body.style.removeProperty("height");
        document.documentElement.style.height = "100vh";

        // Open modal checkout
        this.openModalCheckout();
      }
    });
  }

  // Initialize event listeners to control the submit button state
  initSubmitBtn() {
    this._address = document.querySelector("#address");
    this._apartmentNumber = document.querySelector("#apartment");
    [
      this._address,
      this._apartmentNumber,
      this._email,
      this._name,
      this._phoneNumber,
    ].forEach((el) => {
      if (el) {
        el.addEventListener("input", this.toggleSubmitButton.bind(this));
      }
    });

    this._country.addEventListener(
      "change",
      this.toggleSubmitButton.bind(this),
    );
  }

  renderAddress(handler) {
    if (!this._bigBasket) {
      return;
    }

    this._bigBasket.onclick = handler;
  }

  // Delivery info data is located in this._data
  renderDataDelivery(data) {
    const addressFormTemplate = `
    <div class="address-container">
      <label for="address" class="label-input">
        ${i18next.t("labels.address")} <span class="required-field"> * </span>
      </label>
      <input
        type="text"
        class="user-input w-input"
        maxlength="256"
        name="address"
        placeholder=""
        id="address"
        required
        autocomplete="off"
      />
      <span class="address-validation" aria-live="polite">
        ${i18next.t("address.completeAddress")}
      </span>
      <div class="result-address"></div>
    </div>
    <label for="apartment" class="label-input">
      ${i18next.t("address.aptSuiteBuilding")}
    </label>
    <input
      type="number"
      min="0"
      class="user-input w-input"
      name="apartment"
      placeholder=""
      id="apartment"
    />
  `;

    this._clear();

    // Insert the template litteral into the delivery form
    this._addressForm.innerHTML = addressFormTemplate;
    this._address = document.querySelector("#address");
    this._apartmentNumber = document.querySelector("#apartment");

    if (!data) {
      return;
    }
    this._data = data;
    this._address.value = data.address ?? "";
    this._apartmentNumber.value = data.apartmentNumber ?? "";
    this._phoneNumber.value = data.phoneNumber ?? "";
    this._email.value = data.email ?? "";
    this._name.value =
      (data.name && data.name.trim()) ||
      `${(data.firstName ?? "").trim()} ${(data.lastName ?? "").trim()}`.trim() ||
      "";
  }

  // Pickup info data is located in this._data
  renderDataPickup(data) {
    if (!data) {
      return;
    }
    this._data = data;
    this._phoneNumber.value = data.phoneNumber ?? "";
    this._email.value = data.email ?? "";
    this._name.value =
      (data.name && data.name.trim()) ||
      `${(data.firstName ?? "").trim()} ${(data.lastName ?? "").trim()}`.trim() ||
      "";
  }

  // Called by the controller after each address lookup.
  // hasAddresses: true if the API returned selectable address suggestions.
  // validationKey: an i18n key describing the validation error, or null if valid.
  setLookupState(hasAddresses, validationKey) {
    this._lookupState = { hasAddresses, validationKey };
  }

  // Toggle the state of the submit button based on input fields
  toggleSubmitButton() {
    const MAX_NAME_LENGTH = 50;
    const MAX_ADDRESS_LENGTH = 256;
    const MAX_EMAIL_LENGTH = 256;
    const MAX_PHONE_LENGTH = 10;
    const MIN_APARTNUMBER_VALUE = 0;

    const formNotValid = () => {
      if (this._address || this._apartmentNumber) {
        return (
          this._address.value === "" ||
          this._address.value.length > MAX_ADDRESS_LENGTH ||
          this._apartmentNumber.value < MIN_APARTNUMBER_VALUE ||
          this._country.value === "" ||
          this._email.value === "" ||
          this._email.value.length > MAX_EMAIL_LENGTH ||
          this._name.value === "" ||
          this._name.value.length > MAX_NAME_LENGTH ||
          this._phoneNumber.value === "" ||
          this._phoneNumber.value.length > MAX_PHONE_LENGTH
        );
      }
      // For pickup mode, only validate non-address fields
      return (
        this._country.value === "" ||
        this._email.value === "" ||
        this._email.value.length > MAX_EMAIL_LENGTH ||
        this._name.value === "" ||
        this._name.value.length > MAX_NAME_LENGTH ||
        this._phoneNumber.value === "" ||
        this._phoneNumber.value.length > MAX_PHONE_LENGTH
      );
    };

    if (formNotValid()) {
      // Disable submit button
      this._continueBtn.disabled = true;
    } else {
      this._continueBtn.disabled = false;
    }
  }

  validateAddress() {
    const _addressField = document.querySelector("#address");
    const _addressValidationField = document.querySelector(
      ".address-validation",
    );
    const MIN_ADDRESS_LENGTH = 10;

    if (_addressField.value.trim().length < MIN_ADDRESS_LENGTH) {
      return this._showAddressError(i18next.t("address.completeAddress"));
    }

    if (!this._isAddressLookupValid()) {
      return this._showAddressError(i18next.t(this._lookupState.validationKey));
    }

    // Hide address validation field
    _addressValidationField.style.display = "none";

    // Adjust margin
    _addressValidationField.style.marginBottom = "12.5px";

    return true;
  }

  // Validate email
  validateEmail() {
    if (!this.testEmail(this._email.value)) {
      const SHAKEDURATION = 1000;
      const emailContainer = document.querySelector(".email-container");

      // Show email validation field
      this._emailValidationField.style.display = "block";

      // Shake element
      emailContainer.classList.add("shake");

      // Remove the 'shake' class after 1 second
      setTimeout(() => {
        emailContainer.classList.remove("shake");
      }, SHAKEDURATION);
    } else if (this.testEmail(this._email.value)) {
      // Hide email validation field
      this._emailValidationField.style.display = "none";
    }
  }

  // Validate phone number
  validatePhoneNumber() {
    // Get the current pattern from the input's pattern attribute
    const currentPattern = new RegExp(this._phoneField.pattern, "u");

    if (!currentPattern.test(this._phoneNumber.value)) {
      const SHAKEDURATION = 1000;
      const phoneNumberContainer = document.querySelector(
        ".block-phone-number",
      );

      // Show phone number validation field
      this._phoneNumberValidationField.style.display = "block";

      // Shake element
      phoneNumberContainer.classList.add("shake");

      // Remove the 'shake' class after 1 second
      setTimeout(() => {
        phoneNumberContainer.classList.remove("shake");
      }, SHAKEDURATION);
    } else if (currentPattern.test(this._phoneNumber.value)) {
      // Hide phone number validation field
      this._phoneNumberValidationField.style.display = "none";
    }
  }
}

export default new DeliveryView();
